<template>
	<div class="footer">
		{{"Copyright © 版权所有，并保留所有权利"}}
	</div>
</template>
<script>
	export default {
   }
</script>
<style scoped>
	.footer {
		position: fixed;
		bottom: 0;
		z-index: 100;
		height: 50px;
		background: #07c4a8;
		color: #fff;
		text-align: center;
		width: 100%;
		line-height: 50px;
	}
</style>